import type { ProspectResponse } from '@common/types/prospects';
import { FormControl, FormControlLabel, Grid, Radio, RadioGroup, Typography } from '@mui/material';
import CurrencyInput from '@/components/CurrencyInput';
import { radioStyles } from './PricingInputStyles';

interface Props {
    prospect: ProspectResponse;
    handleValueChange: (name: string, value: any) => any;
    readOnly: boolean;
}

export default function PrivateLenderPricingInput({
    prospect,
    handleValueChange,
    readOnly,
}: Props) {
    const { prospectSummary } = prospect;
    //constants
    //Todo: keeping this constant for any future requirements for static questions.
    const pricingQuestions: { label: string; name: string; value: any }[] = [];

    return (
        <>
            <Grid item xs={6} lg={4}>
                <CurrencyInput
                    sx={{
                        pointerEvents: readOnly ? 'none' : undefined,
                    }}
                    label="Total loan amount"
                    fullWidth
                    allowDecimal
                    name={'purchasePrice'}
                    value={prospectSummary.purchasePrice}
                    onChange={(ev) => {
                        if (!readOnly) {
                            handleValueChange('purchasePrice', ev);
                        }
                    }}
                />
            </Grid>
            {pricingQuestions.map((question, index) => {
                return (
                    <div key={question.label + index}>
                        <Typography variant="body1">{question.label}</Typography>
                        <FormControl>
                            <RadioGroup
                                sx={{
                                    ...radioStyles,
                                    pointerEvents: readOnly ? 'none' : undefined,
                                }}
                                row
                                aria-labelledby={question.label}
                                name={question.name}
                                value={question.value}
                                onChange={(ev) => {
                                    if (!readOnly) {
                                        handleValueChange(question.name, ev.target.value);
                                    }
                                }}
                            >
                                <FormControlLabel value={true} control={<Radio />} label="Yes" />
                                <FormControlLabel value={false} control={<Radio />} label="No" />
                            </RadioGroup>
                        </FormControl>
                    </div>
                );
            })}
        </>
    );
}
